<template>
      <div style="background:#f5f5f5">
          <sbspSalaryFilter :filterList.sync="filterList">
             <el-form-item label="工资月份：" style="margin-right:40px;">
            <div>
                  <el-select  v-model="filterList[0].value"   placeholder="请选择" style="width:90px;">
                    <el-option  v-for="item in filterList[0].options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                  </el-select>
                  <el-date-picker v-if="filterList[0].value=='qt'" v-model="filterList[0].value2"  style="width:230px;margin-left:4px;"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
              </div>
             </el-form-item>
          </sbspSalaryFilter>
          <div class="carBox">
              <cardTwo style="min-height:287px;" v-for="(cardData,i) in cardDatas" :key="i" :cardData='cardData' :labels='labels'>
                   <leftButton title="支付文件" @click="details()" style="top:74px;"></leftButton>
                   <leftButton title="删除批次" @click="details()" style="top:99px;"></leftButton>
                    <leftButton title="确认发放" @click="details()" style="top:124px;"></leftButton>
                    <leftButton title="查看详情" @click="details()" style="top:149px;"></leftButton>
              </cardTwo>

          </div>
          <p class="more">
            <span>查看更多></span>

            </p>
      </div>

</template>

<script>
  import sbspSalaryFilter from "@/views/demo/salary/template/sbsp-salary-filter.vue"
  import cardTwo from "@/views/demo/salary/template/cardTwo.vue"
   import leftButton from "@/views/demo/salary/template/left-button.vue"
  export default {
    name: "approval",
    components: {
      sbspSalaryFilter,
      cardTwo,
      leftButton
    },
    data() {
      return {
          labels:["工资月份","发薪人数","发薪金额","薪酬组","发放类型"],
        cardDatas:[
            {
            title:'202002工资',
            keys:['工资','离职金'],
            info:['100','200','300','北京分公司薪酬组','线下发薪'],
            state:0    //0表示发放中，1表示发放完成
          },


            {
            title:'202001付款通知单',
            keys:['工资','离职金'],
             info:['100','200','300','北京分公司薪酬组','系统发薪'],
              grantInfo:{
                 num1:1,
                num2:3,
                num3:5,
                num4:6,
           },
              state:1    //0表示发放中，1表示发放完成
          },
           {
            title:'202001付款通知单',
            keys:['工资','离职金'],
          info:['100','200','300','北京分公司薪酬组','系统发薪'],
              grantInfo:{
                 num1:1,
                num2:3,
                num3:5,
                num4:0,
           },
          state:1    //0表示发放中，1表示发放完成
          },
            {
            title:'202001付款通知单',
            keys:['工资','离职金'],
           info:['100','200','300','北京分公司薪酬组','中智代发'],
              grantInfo:{
                 num1:1,
                num2:3,
                num3:5,
                num4:0,
           },
     state:0    //0表示发放中，1表示发放完成
          },
            {
            title:'202001付款通知单',
            keys:['工资','离职金'],
           info:['100','200','300','北京分公司薪酬组','线下发薪'],
              grantInfo:{
                 num1:1,
                num2:3,
                num3:5,
                num4:0,
           },
          state:0    //0表示发放中，1表示发放完成
          },
            {
            title:'202001付款通知单',
            keys:['工资','离职金'],
          info:['100','200','300','北京分公司薪酬组','线下发薪'],
              grantInfo:{
                 num1:1,
                num2:3,
                num3:5,
                num4:0,
           },
           state:0    //0表示发放中，1表示发放完成
          },
        ],
        filterList: [
          { text: "工资月份", type: 'select-timer',value:'0',value2:'',
            options:[{
                value: '0',
                label: '一周内'
              }, {
                value: '1',
                label: '一月内'
              },{
                value: 'qt',
                label: '其他'
              }
              ]
          },
          { text: "批次名称", type: 'text',value:''},
          { text: "薪酬组", type: 'select',value:'0',
            options: [{
                value: '0',
                label: '黄金糕'
              }, {
                value: '1',
                label: '双皮奶'
              }, {
                value: '2',
                label: '蚵仔煎'
              }, {
                value: '3',
                label: '龙须面'
              }, {
                value: '4',
                label: '北京烤鸭'
              }]
          },
          { text: "审批状态", type: 'radio',value:'',
            options:[{
                value: '0',
                label: '待审批'
              }, {
                value: '1',
                label: '已审批'
              }]
          },
          { text: "社保月份", type: 'timer',value:'' },
           { text: "计税类型", type: 'text',value:'' },
        ]
      };
    },
    created(){
      this.filterLists = JSON.parse(JSON.stringify(this.filterList))
    },
    methods: {
      details(){
        alert(111)
      },
    }
  };
</script>

<style scoped >
  .carBox{
    margin-top:10px;
    display: flex;
    flex-wrap: wrap;
  }
  .more span{
font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(64,158,255,1);
line-height:18px;
cursor: pointer;
  }
  .more{
    text-align: right;
  }
  .more span:hover{
    text-decoration: underline;

  }


</style>
